import { Badge, Text } from "@shopify/polaris";
import { Handle, Position } from "reactflow";

function WaitingNode({ id, data }) {
  const totalMinutes = data.duration ?? 0;
  const conditionDays = Math.floor(totalMinutes / 1440);
  const conditionHours = Math.floor((totalMinutes - conditionDays * 1440) / 60);
  const conditionMinutes =
    totalMinutes - conditionDays * 1440 - conditionHours * 60;

  return (
    <div className="waiting-node" onClick={() => data.clickNode(id)}>
      <Handle type="target" position={Position.Left} />
      <br />
      {data.type === "" ? (
        <Text variant="bodySm">Wait...</Text>
      ) : data.type === "duration" ? (
        <div className="flex justify-between">
          <div className="mx-5" />
          <div className="ml-1 mt-1">
            <Text variant="bodySm">
              {`Wait ${conditionDays} ${conditionDays > 1 ? "days" : "day"}, 
              ${conditionHours} ${conditionHours > 1 ? "hours" : "hour"}, 
              ${conditionMinutes} ${
                conditionMinutes > 1 ? "minutes" : "minute"
              }`}
            </Text>
          </div>
          {data.waitingsCount && data.waitingsCount > 0 ? (
            <div className="mx-4">
              <Badge tone="info">
                <Text variant="bodySm">{data.waitingsCount}</Text>
              </Badge>
            </div>
          ) : (
            <div className="mx-5" />
          )}
        </div>
      ) : data.type === "whatsapp_message" ? (
        <div className="flex flex-col items-center gap-1">
          <Text variant="bodySm">Wait for an answer</Text>
          {data.storeAnswer && (
            <div className="flex items-center gap-1">
              <Text variant="bodySm">and store it in</Text>
              <Badge tone={data.storageField ? "info" : "critical"}>
                <Text variant="bodySm">
                  {data.storageField || "no field selected"}
                </Text>
              </Badge>
            </div>
          )}
        </div>
      ) : data.type === "whatsapp_message_status" ? (
        <Text variant="bodySm">Wait for message to be read</Text>
      ) : null}
      <br />
      <Handle type="source" position={Position.Right} />
    </div>
  );
}

export default WaitingNode;
